import {
  AccountProductEnum,
  IAccount,
  LendingDisbursementPaymentOptionsSuccess,
  LendingPaymentOptionDetails,
  LendingPaymentSource,
} from '@varo/graphql-schema-types';

export const getSavingAccount = (
  accounts: IAccount[],
): IAccount | undefined => {
  return accounts?.find(
    (account) => account?.product === AccountProductEnum.Savings,
  );
};

// Remove non-numeric characters (except for decimal points)
export const removeDollarPrefix = (amount: string) =>
  amount?.replace(/[^0-9.]/g, '');

export const getAvailableBalance = (account: IAccount | undefined): string => {
  if (!account) {
    return '$0';
  }

  for (const detail of account.details || []) {
    const balanceItem = detail.items.find(
      (item) => item.key === 'available_balance',
    );
    if (balanceItem) {
      return balanceItem.value;
    }
  }

  return '$0';
};

export const getCheckingAccount = (
  accounts: IAccount[],
): IAccount | undefined => {
  return accounts?.find(
    (account) => account?.product === AccountProductEnum.Checking,
  );
};

export const getInternalAccountAvailableBalance = (
  lendingPaymentOption: LendingPaymentOptionDetails | undefined,
): string | undefined => {
  if (!lendingPaymentOption || !lendingPaymentOption.balance) {
    return undefined;
  }
  return lendingPaymentOption.balance?.formatted;
};

export const getAccountType = (
  accounts?: LendingDisbursementPaymentOptionsSuccess,
): Record<string, LendingPaymentOptionDetails | undefined> => {
  let savingsAccounts: LendingPaymentOptionDetails | undefined = undefined;
  let checkingAccount: LendingPaymentOptionDetails | undefined = undefined;

  accounts?.options.forEach((option) => {
    option.details.forEach((detail) => {
      if (detail.source === LendingPaymentSource.InternalSavings) {
        savingsAccounts = detail;
      }
      if (detail.source === LendingPaymentSource.InternalDda) {
        checkingAccount = detail;
      }
    });
  });
  return { checkingAccount, savingsAccounts };
};

export const getTransferFieldSecondaryText = (
  selectedAccount?: LendingPaymentOptionDetails,
  availableBalanceLabel?: string,
): string => {
  if (!selectedAccount) {
    return '';
  }

  if (
    selectedAccount.source === LendingPaymentSource.ExternalDebitCard ||
    (selectedAccount.source === LendingPaymentSource.ExternalAch &&
      selectedAccount.network)
  ) {
    return selectedAccount.network ? selectedAccount.network : '';
  }

  if (
    selectedAccount?.source === LendingPaymentSource.InternalDda ||
    selectedAccount?.source === LendingPaymentSource.InternalSavings
  ) {
    const internalAvailable =
      getInternalAccountAvailableBalance(selectedAccount);
    return internalAvailable
      ? `${availableBalanceLabel} ${internalAvailable}`
      : '';
  }

  return '';
};
